const StaffRoutes = {
  getAllStaff: "/auth/staff",
  addStaff: "/auth/staff/add",
};

export default StaffRoutes;
